import BaseMenuFetchComponent from '../base-menu-fetch';

export interface MenuFastbootComponentArgs {}

export default class MenuFastbootComponent extends BaseMenuFetchComponent {}
